// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2nOuM","footer":"ModalInfo_footer__A8EuP"};